export default str => str.trim()
